import React, { lazy, Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { PopupMessage } from '@/components/common/PopupMessage/PopupMessage';
import FullPageLoader from '@/components/layout/FullPageLoader/FullPageLoader';
import { useSelector } from 'react-redux';
import { RootState } from '@/models';
import styles from './AppLayout.module.scss';

const CheckoutModal = lazy(() =>
  import('@/modals/CheckoutModal/CheckoutModal').then(module => ({
    default: module.CheckoutModal,
  }))
);

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { showFullPageLoader } = useSelector(
    (state: RootState) => state.appData
  );

  return (
    <div className={styles.appWrapper}>
      <Suspense fallback={<FullPageLoader />}>
        <PopupMessage />
        <CheckoutModal />
        <ToastContainer />
        {showFullPageLoader && <FullPageLoader />}
        {children}
      </Suspense>
    </div>
  );
};

export default AppLayout;
